module.exports = __webpack_public_path__ + "media/easy-setup.964bf4ed.mp4";